import $ from 'jquery';
import { EventEmitter } from 'events';

import  { transitionEnd } from '../shared';

let instance = null;

export class VideoPanel extends EventEmitter {
    constructor() {
        super();
        if(!instance){

            console.log('init video panel');
            this.isPlaying = false;
            this.videoContainerWrapper = $('.video-container__wrapper');
            this.videoContainer = $('.video-container');
            this.videoCloseBtn = $('.video-container__inner__close');
            this.videoContaineeInner = $('.video-container__inner');
            this.video = $('.video-container video');
            this.buffering = $('.video-buffering');
            this.toggleBtn = $('#video-toggle-btn');
            this.isFullscreen = false;

            this.originWidth = this.videoContainer.css('width');

            this.videoContaineeInner.bind('click', (e) =>{
                e.preventDefault();
                e.stopPropagation();
                this.toggle();
            });

            this.toggleBtn.bind('click', (e) =>{
                e.preventDefault();
                e.stopPropagation();
                this.toggle();
            });

            this.videoCloseBtn.bind('click', (e)=> {
                e.preventDefault();
                e.stopPropagation();
                this.stop();
            });

            this.onEndVideo = this.onEndVideo.bind(this);

            instance = this;
        }
        return instance;
    }

    setSrc(link) {
        this.video.attr('src', link);
    }

    play() {
        this.isPlaying = true;
        this.toggleBtn.css('display','none');
        this.buffering.css('display','block');
        this.videoContainerWrapper.css('display','block');

        setTimeout( () => {
            this.videoContainerWrapper.addClass('fadeIn');
        }, 100);

        setTimeout( () => {
            this.videoContainer.css('display','block');
            this.video[0].currentTime = 0;
            this.video[0].play();
            this.video[0].addEventListener("ended", this.onEndVideo);

            // this.getBuffering();
        }, 400);
    }

    stop() {
        this.video[0].currentTime = 0;
        this.video[0].pause();

        setTimeout( () => {
            this.toggleBtn.css('display','none');
            this.videoContainer.css('display','none');
            this.buffering.css('display','none');
            this.videoContainerWrapper.removeClass('fadeIn');
            this.video[0].removeEventListener("ended", this.onEndVideo);

            transitionEnd(this.videoContainerWrapper, () => {
                this.videoContainerWrapper.css('display','none');
            });

            if(!this.isFullscreen) this.emit('onCloseVideoPanel');
        },100);
    }

    onEndVideo() {
        console.log('end');
        this.stop();
    }

    getBuffering() {
        let _that = this;
        this.video[0].addEventListener('progress', function() {
            console.log('add progress');
            let range = 0;
            const bf = this.buffered;
            const time = this.currentTime;
            let loadStartPercentage;
            let loadEndPercentage;

            try {

            }catch (e) {}

            while(!(bf.start(range) <= time && time <= bf.end(range))) {
                range += 1;
            }
            loadStartPercentage = bf.start(range) / this.duration;
            loadEndPercentage = bf.end(range) / this.duration;


            //https://developer.mozilla.org/en-US/docs/Web/Apps/Fundamentals/Audio_and_video_delivery/buffering_seeking_time_ranges
            // take a look
            let loadPercentage = loadEndPercentage - loadStartPercentage;
            let bufferingPercentage = Math.floor(loadPercentage * 1000);
            if(isNaN(bufferingPercentage)) {
                bufferingPercentage = 0;
            }
            _that.buffering.html(bufferingPercentage + '%');



            if(bufferingPercentage >= 100) {
                // _that.videoContaineeInner.css('opacity', 1);
                // _that.video[0].currentTime = loadPercentage;
                // _that.video[0].play();
                _that.buffering.css('display',' none');
                _that.buffering.html('0%');
            }
            // suggestion: don't use this, use what's below
        });
    }

    toggle() {
        if(this.isPlaying) {
            this.video[0].pause();
            this.toggleBtn.css('display','block');
            this.isPlaying = false;
            return;
        }else {
            this.video[0].play();
            this.toggleBtn.css('display','none');
            this.isPlaying = true;
        }
    }

    fullscreen() {
        this.isFullscreen = true;
        this.videoContainer.css('width', '100%');
        this.videoCloseBtn.addClass('fullscreen-mode');
    }

    cancalFullScreen() {
        this.isFullscreen = false;
        this.videoContainer.css('width', this.originWidth);
        this.videoCloseBtn.removeClass('fullscreen-mode');
    }
}
